import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Footer from 'components/Footer'

const getFooter = (pathname) => {
    return pathname.indexOf('/_secure/cart') === -1 && pathname.indexOf('/checkout') === -1 && pathname.indexOf('/login-page') === -1 && pathname.indexOf('/centro-ayuda') === -1 && pathname.indexOf('/new-checkout') === -1|| pathname.indexOf('/centro-ayuda') !== -1;
}

let sourceApp = false;
const FooterRouter = (props) => {
    const [withFooter, setWithFooter] = useState(getFooter(props.location.pathname));

    useEffect(() => {
        const {pathname, search} = props.location;

        if(search.includes('source=app')){
            sourceApp = true;
        }

        setWithFooter(getFooter(pathname));

    }, [props.location]);

    return <>
        {withFooter && !sourceApp &&<Footer />}
    </>;
}

FooterRouter.propTypes = {
    location: PropTypes.object
};

export default withRouter(FooterRouter);
